<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/audit-intern/table">实习生管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">实习生批量任务列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                border
                highlight-current-row
                stripe
                style="width: 100%">
        <el-table-column label="ID"
                         min-width="50"
                         prop="id"></el-table-column>
        <el-table-column label="文件名称"
                         min-width="120"
                         prop="name"></el-table-column>
        <el-table-column label="上传用户"
                         min-width="120"
                         prop="username">
          <template slot-scope="scope">
            {{ scope.row.creator_name }} / {{ scope.row.creator_id }}
          </template>
        </el-table-column>
        <el-table-column label="任务进度"
                         min-width="120">
          <template slot-scope="scope">
            <div class="combined-progress">
              <div class="combined-progress__bar is-success"
                   :style="{ width: getPercentage(scope.row) + '%' }"
                   :title="`成功 ${getPercentage(scope.row)}%`">
                <span v-if="getPercentage(scope.row) >= 12">{{ getPercentage(scope.row) }}%</span>
              </div>
              <div class="combined-progress__bar is-error"
                   :style="{ width: getErrorPercentage(scope.row) + '%' }"
                   :title="`失败 ${getErrorPercentage(scope.row)}%`">
                <span v-if="getErrorPercentage(scope.row) >= 12">{{ getErrorPercentage(scope.row) }}%</span>
              </div>
            </div>
            成功:{{ scope.row.success_count }} 错误:{{ scope.row.error_count }} <br>
            已处理(含表头): {{ scope.row.processed_line }}
          </template>
        </el-table-column>
        <el-table-column label="任务类型"
                         min-width="120"
                         prop="task_type">
          <template slot-scope="scope">
              <span v-for="item in crontabTaskType"
                    v-if="scope.row.task_type === item.value">
                <router-link :to="generateLink({task_type: item.value})">
                   {{ item.label }}
                </router-link>
              </span>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         min-width="120"
                         prop="status">
          <template slot-scope="scope">
            <span v-for="item in crontabStatus"
                  v-if="scope.row.status === item.value">{{ item.label }}</span>
            <span v-if="scope.row.status === 3 && scope.row.error_message">{{ scope.row.error_message }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间 更新时间"
                         width="160"
                         prop="created_at">
          <template slot-scope="scope">
            {{ scope.row.created_at }}<br>
            {{ scope.row.updated_at }}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <button-gutter>
              <el-button size="mini"
                         v-if="scope.row.upload_path"
                         type="primary"
                         @click="onDownSourceFile(scope.row.upload_path)">
                下载源文件
              </el-button>
              <el-button size="mini"
                         v-if="scope.row.error_path"
                         type="danger"
                         @click="onDownSourceFile(scope.row.error_path)">
                下载错误行
              </el-button>
              <el-button size="mini"
                         v-if="scope.row.export_path"
                         type="success"
                         @click="onDownSourceFile(scope.row.export_path)">
                下载导出文件
              </el-button>
              <el-button size="mini"
                         type="danger"
                         v-if="scope.row.status === 1"
                         @click="onCancelTaskBatch(scope.row)">
                取消任务
              </el-button>
            </button-gutter>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination :current-page="pagination.current_page"
                       :page-size="pagination.per_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :total="pagination.total"
                       background
                       layout="total, sizes, prev, pager, next, jumper"
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'

export default {
  mixins: [table],
  components: {},
  data () {
    return {}
  },
  computed: Vuex.mapState({
    crontabStatus: state => state.auditCrontab.status,
    crontabTaskType: state => state.auditCrontab.task_type,
    user: state => state.login.user,
  }),
  created () {
  },
  methods: {
    ...Vuex.mapActions([]),
    ...request.map(['queryCrontabJobs', 'queryCronSubJobs']),
    getTableData (params) {
      return request.common('queryCrontabJobsApi', params)
    },
    generateLink (item) {
      const currentQuery = {...this.$route.query, ...item}
      return '?' + new URLSearchParams(currentQuery).toString()
    },
    onDownSourceFile (path) {
      downloadJS(path, false, false, {
        'SJ-Auth-Token': getToken()
      })
    },
    getPercentage (row) {
      if (!row.total_count) {
        return 0
      }
      let percentage = (row.success_count || 0) / row.total_count * 100
      return parseFloat(percentage.toFixed(2))
    },
    getErrorPercentage (row) {
      if (!row.total_count) {
        return 0
      }
      let percentage = (row.error_count || 0) / row.total_count * 100
      return parseFloat(percentage.toFixed(2))
    },
    onCancelTaskBatch (row) {
      request.common('cancelTaskBatch', {id: row.id, page: this.page_type}).then(({data}) => {
        this.$message.success('取消批量任务(' + row.id + ')成功')
        this.onRefresh()
      })
    },
  },
}
</script>

<style scoped>
.combined-progress {
  display: flex;
  width: 100%;
  height: 18px;
  border-radius: 9px;
  background-color: #ebeef5;
  overflow: hidden;
}

.combined-progress__bar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;
  font-size: 12px;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  transition: width .3s ease;
}

.combined-progress__bar.is-success {
  background-color: #409EFF;
}

.combined-progress__bar.is-error {
  background-color: #F56C6C;
}
</style>



// WEBPACK FOOTER //
// src/views/audit-intern/pages/AuditInternJobsTable.vue